module.exports = __webpack_public_path__ + "img/260123_EBC_Trading_Academy_Banner_01_SC_508x600_Final.06ff7056.gif";